module.exports = __webpack_public_path__ + "static/img/orsayCourse.6afd465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orsayCourse.png
// module id = VK7f
// module chunks = 1